import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { SidebarContent } from "@/components/layout/Sidebar";
import { Header } from "@/components/layout/Header";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { cn } from "@/lib/utils";

export default function AppShell() {
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem("wellora_sidebar_collapsed") === "1"
  );
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggle = () => {
    setCollapsed((c) => {
      const next = !c;
      localStorage.setItem("wellora_sidebar_collapsed", next ? "1" : "0");
      return next;
    });
  };

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Desktop sidebar */}
      <aside
        className={cn(
          "fixed inset-y-0 left-0 z-30 hidden border-r border-slate-200 transition-[width] duration-200 lg:block",
          collapsed ? "w-20" : "w-64"
        )}
        data-testid="desktop-sidebar"
      >
        <SidebarContent collapsed={collapsed} onToggle={toggle} />
      </aside>

      {/* Mobile sidebar */}
      <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
        <SheetContent side="left" className="w-64 p-0" data-testid="mobile-sidebar">
          <SidebarContent collapsed={false} showToggle={false} onNavigate={() => setMobileOpen(false)} />
        </SheetContent>
      </Sheet>

      {/* Main */}
      <div className={cn("transition-[padding] duration-200", collapsed ? "lg:pl-20" : "lg:pl-64")}>
        <Header onMobileMenu={() => setMobileOpen(true)} onToggleSidebar={toggle} />
        <main className="p-4 sm:p-6 lg:p-8" data-testid="app-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
